import styled from "styled-components";
export const ProductContainer = styled.section`
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
  display: flex;
  margin: 20px 0;
  flex-wrap: wrap;
  overflow: hidden;

  .image {
    width: 27%;

    img {
      width: 100%;
    }
  }

  .content {
    width: 50%;
    padding: 16px;

    .title-area {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .labels {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 16px;

      .label {
        border-radius: 15px;
        border: solid 0 #050508;
        background-color: #dce5e5;
        font-size: 12px;
        font-weight: 500;
        padding: 6px 16px 2px 16px;
        margin-top: 6px;
        width: 100%;
      }
    }

    .description {
      font-size: 0.8em;
    }

    .date {
      color: #221C35;
      margin-top: 8px;
    }

    .colors {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      margin-top: 32px;

      li {
        margin-left: 16px;
        width: 42px;
        height: 42px;
        border-radius: 42px;
        box-shadow: 0 0 5px rgb(0 0 0 / 20%);
      }
    }
  }

  .price {
    background-color: #221C35;
    background-image: linear-gradient(to top, #151221, #2d2546);
    color: #fff;
    width: 23%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: ${({theme}) => theme.sizes.font3};
    cursor: pointer;

    .data {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      span {
        margin-bottom: 8px;
      }
    }

    .icon {
      font-size: 64px;
    }
  }

  @media only screen and (max-width: 1024px) {
    .image {
      width: 100%;
    }

    .price {
      width: 50%;
    }
  }
  @media only screen and (max-width: 760px) {
    .image {
      width: 100%;
    }

    .content {
      position: relative;
      width: 100%;
      padding: 16px;

      .title-area {
        align-items: baseline;

        .number {
          font-size: ${({theme}) => theme.sizes.fontxs};
        }
      }

      .colors {
        position: absolute;
        margin-top: 0;
        top: -44px;

        li {
          margin-left: 8px;
          width: 32px;
          height: 32px;
        }
      }
    }

    .price {
      width: 100%;
      flex-direction: row;
      padding: 16px 0;
      justify-content: space-around;
      font-size: ${({theme}) => theme.sizes.font2};

      .data {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        span {
          margin-bottom: 8px;
        }
      }

      .icon {
        font-size: 44px;
      }
    }
  }
`;
